/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

export const navigateTo = (url: string): void => {
  window.location.href = url;
};

export const navigateFromWindowTo = (win: Window, url: string) => {
  win.location.href = url;
};

export const getCurrentUrl = (): string => window.location.href;

export const populateUrlWithParameter = (
  url: string,
  sessionTrackingId: string,
  meetingId?: string
): string => {
  if (!url.includes('sessionTrackingId') && sessionTrackingId) {
    let urlWithParams = `${url}?sessionTrackingId=${sessionTrackingId}`;
    if (!url.includes('/join/') && !url.includes('meetingId=') && meetingId) {
      urlWithParams += '&meetingId=' + meetingId;
    }
    return urlWithParams;
  }
  return url;
};

export const reloadPage = (url: string) => {
  window.history.replaceState({}, document.title, url);
  window.location.reload();
};

export const reloadPageWithSessionTrackingId = (
  meetingId: string | undefined,
  sessionTrackingId: string
) => {
  // TODO Rewrite this if branches have a proper setup
  // Attaching the meetingId is required for ulf branches now, since it does not support meetingId in the path yet and is removed on page visit
  const urlWithParams = populateUrlWithParameter(
    getCurrentUrl(),
    sessionTrackingId,
    meetingId
  );
  reloadPage(urlWithParams);
};
